import { EmptystateDataFlowColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

const FlowsProjectsEmpty = () => (
  <EmptyState
    icon={EmptystateDataFlowColored}
    title="No projects yet"
    caption="Flows projects from your linked organization will show up here."
  />
);

export default FlowsProjectsEmpty;
